import HomepageContents from './HomepageContents';

export default HomepageContents;
